import { createFileRoute, useSearch } from '@tanstack/react-router';
import { MagicRedeemPage } from '@/components/auth/MagicRedeemPage';

export interface MagicSearch {
  token?: string;
}

export const Route = createFileRoute('/_public/auth/magic')({
  validateSearch: (search: Record<string, unknown>): MagicSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: MagicRedeemRoute,
});

function MagicRedeemRoute(): JSX.Element {
  const { token } = useSearch({ from: '/_public/auth/magic' });
  return <MagicRedeemPage token={token} />;
}
